var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"card-box card__indicator w-100",attrs:{"body-class":"py-3"}},[_c('div',{staticClass:"card-indicator",class:_vm.indicatorClass}),_c('b-card-body',{attrs:{"body-class":"p-0"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }